export const SPOUSE_ON_CONTRACT_NA = 'NOT_ANSWERED'
export const SPOUSE_ON_CONTRACT_PRESENT = 'PRESENT'
export const SPOUSE_ON_CONTRACT_NOT_PRESENT = 'NOT_PRESENT'
export const SOMEONE_ELSE = 'Someone Else'

export const MARRIED_MAN = 'MARRIED_MAN'
export const MARRIED_WOMAN = 'MARRIED_WOMAN'
export const SINGLE_MAN = 'SINGLE_MAN'
export const SINGLE_WOMAN = 'SINGLE_WOMAN'
export const MARRIED_GROUP = [MARRIED_MAN, MARRIED_WOMAN]
export const SINGLE_GROUP = [SINGLE_MAN, SINGLE_WOMAN]

export const MAX_COBUYERS = 3

export const MARITAL_STATUS_OPTIONS = [
  {
    text: 'A Single Man',
    value: SINGLE_MAN,
  },
  {
    text: 'A Single Woman',
    value: SINGLE_WOMAN,
  },
  {
    text: 'A Married Man',
    value: MARRIED_MAN,
  },
  {
    text: 'A Married Woman',
    value: MARRIED_WOMAN,
  },
]

export const OWNING_ENTITY_OPTIONS = [
  {
    label: 'Myself as an individual',
    value: 'INDIVIDUAL',
  },
  {
    label: 'Myself with Co-Buyer',
    value: 'COBUYER',
  },
  {
    label: 'Entity',
    value: 'ENTITY',
  },
  {
    label: 'Trust',
    value: 'TRUST',
  },
  {
    label: 'Retirement Plan',
    value: 'RETIREMENT_PLAN',
  },
]

export const OWNING_ENTITY_TYPES = {
  INDIVIDUAL: 'INDIVIDUAL',
  COBUYER: 'COBUYER',
  ENTITY: 'ENTITY',
  TRUST: 'TRUST',
  RETIREMENT_PLAN: 'RETIREMENT_PLAN',
}

export const ENTITY_TYPE_INDIVIDUAL = 'INDIVIDUAL'

export const MULTI_CO_BUYER_FORM_NAME = 'multi_co_buyer'
